import React from 'react';
import { useTranslation } from 'react-i18next';

const ProductDetailHero = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-blue-50/50 via-purple-50/30 to-indigo-50/50 relative overflow-hidden">
      {/* 装饰性背景元素 */}
      <div className="absolute -top-16 -right-16 w-64 h-64 bg-blue-200 rounded-full opacity-10 blur-3xl"></div>
      <div className="absolute top-32 -left-32 w-48 h-48 bg-purple-200 rounded-full opacity-15 blur-2xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Main Headline */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {t('productDetailHero.headline.part1')}
            </span>
            <br />
            <span className="text-gray-900">
              {t('productDetailHero.headline.part2')}
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {t('productDetailHero.subheadline')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailHero;